import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import DonkeyStacker from './DonkeyStacker'

export const DonkeyStackerPage: FC = () => {
  const navigate = useNavigate()
  return <DonkeyStacker onClose={() => navigate(PATHS.arcade.url)} />
}
